export const API_STATUS_CODE_SERVER_ERROR = ['0', 0];
export const API_STATUS_CODE_UN_LOGIN = ['-101', '-100', -101, -100];
